import { render } from "./GfbOptionDisplay.vue?vue&type=template&id=46d0956f&scoped=true"
import script from "./GfbOptionDisplay.vue?vue&type=script&lang=js"
export * from "./GfbOptionDisplay.vue?vue&type=script&lang=js"

import "./GfbOptionDisplay.vue?vue&type=style&index=0&id=46d0956f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d0956f"]])

export default __exports__